import { Component } from '@angular/core';
import { CoreSignalProjectEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Projects') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-coresignalproject-form',
    templateUrl: './coresignalproject.form.component.html'
})
export class CoreSignalProjectFormComponent extends BaseFormComponent {
    public record!: CoreSignalProjectEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

